// extracted by mini-css-extract-plugin
module.exports = {"TL_container":"TrendsList-module__TL_container"};